import { Base64File } from '@synergy/models';
import { createSelector } from 'reselect';
import { nullIfEmpty } from '@synergy/utils';

import { AppState } from '../../../../../store/models/app-state';
import { SponsorBannerDetailRequest } from '../models/sponsor-banner-detail-request';
import { SponsorBannerFormValues } from '../models/sponsor-banner-form-values';

const sponsorBannerDetailState = (state: AppState) => state.contentManagement.sponsorBanner.sponsorBannerDetail;

export const sponsorBannerDetailSelector = createSelector(sponsorBannerDetailState, state => state.sponsorBanner);
export const sponsorBannerDetailRequestingSelector = createSelector(
    sponsorBannerDetailState,
    state => state.requesting
);
export const sponsorBannerDetailFormValues = createSelector(sponsorBannerDetailState, state => {
    const banner = state.sponsorBanner;
    return {
        ...banner,
        image: banner?.image ? { name: '', contentBase64: '', pathname: banner.image['740x370'] } : null,
        validFrom: banner?.validFrom ?? null,
        validTo: banner?.validTo ?? null,
        url: banner?.url ?? '',
        isAnimated: banner?.isAnimated ?? false,
        note: banner?.note ?? '',
        supplier: banner?.supplier,
    } as SponsorBannerFormValues;
});

export const sponsorBannerDetailRequestSelector = (values: SponsorBannerFormValues, file: Base64File | null) =>
    createSelector(sponsorBannerDetailState, state => {
        const request: SponsorBannerDetailRequest = {
            id: state.sponsorBanner?.id,
            url: nullIfEmpty(values.url),
            image: values.image?.contentBase64 ? values.image : null,
            validFrom: values.validFrom ?? new Date(),
            validTo: values.validTo ?? new Date(),
            isAnimated: values.isAnimated,
            note: values.note ?? null,
            supplierId: values.supplier?.id ?? null,
        };

        return request;
    });
